import { useContext } from "react";
import { ApplicationState } from "../../services/context/ApplicationStateContext";
import Button from "../organism/Button";

function InfoSliderDispatcher({ infoQuery }: { infoQuery: string }) {
  const {
    state: { showInfoSlider },
    dispatch: applicationStateDispatcher,
  } = useContext(ApplicationState);

  function toggleInfo() {
    if (showInfoSlider) {
      applicationStateDispatcher({
        type: "HIDE_INFO_SLIDER",
        payload: undefined,
      });
      return;
    }

    applicationStateDispatcher({
      type: "SHOW_INFO_SLIDER",
      payload: {
        infoQuery: infoQuery,
      },
    })
  }
  return (
    <Button
      textInformation={{
        text: "Info",
        fontWeight: "font-semibold",
        fontSize: "text-xs",
      }}
      buttonTheme="transparent"
      className="mx-3 text-primary capitalize"
      onClick={toggleInfo}
    />
  );
}

export default InfoSliderDispatcher;
